import React from 'react';
import { ICreateInitial, IReactDOMAdapter } from './type';
import { CreateInitial } from './createInitial';
import { reactDomAdapter17 } from './adapters/reactDomAdapter17';


export const CreateInitialReact17 = (
    Component: React.ComponentType<any>
): ICreateInitial => {
    return CreateInitial(Component, reactDomAdapter17);
};